var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createTransformer } from 'mobx-utils';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class AspectCollectedSets {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    allOwnTraitsOfKey(traitKey) {
        return this.aspect.traits.filter(t => t.key === traitKey);
    }
    allAtsOfKey(traitKey) {
        return this.aspect.global.aspectKey(traitKey).keyActive.activeTraits;
    }
    get allOwnValuesOfType() {
        return createTransformer((valueType) => this.aspect.attachedTraits
            .filter(at => at.trait.value && at.trait.value.type === valueType)
            .map(at => at.trait.value));
    }
    // actors_onstage: only collect currently visible actors
    get videobg_intent() {
        return null;
    }
}
__decorate([
    memoize
], AspectCollectedSets.prototype, "allOwnValuesOfType", null);
